import React, { Fragment, useEffect, useState } from "react";
import {
  CalendarDays,
  Check,
  CheckCircle,
  CircleCheckBig,
  Coins,
  Eye,
  EyeOff,
  Pencil,
  Trash2,
  Upload,
  User,
  UserCheck,
  UserPlus,
  UserX,
  X,
} from "lucide-react";
import { SolidButton } from "../../global/SolidButton";
import { MyModal } from "../../global/MyModal";
import { useNavigate } from "react-router-dom";
import {
  blockUser,
  getUsers,
  registerUser,
  unblockMember,
  updateUser,
} from "../apps_manage/api";
import MyLoader from "../../util/MyLoader";
import toast from "react-hot-toast";
import { PencilSimpleLine } from "phosphor-react";
import { formatDateTime } from "../../util/MDate";

export function Teams() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const type = [
    { id: 1, label: "Active" },
    { id: 2, label: "Inactive" },
    { id: 3, label: "Invited" },
    { id: 4, label: "Blocked" },
  ];
  const [activeTab, setActiveTab] = useState(1); // Example state for active/inactive tab
  const handleTabClick = (id) => {
    navigate(
      `/teams?status=${
        id === 1
          ? "active"
          : id === 2
            ? "inactive"
            : id === 3
              ? "invited"
              : "blocked"
      }`,
    );
    setActiveTab(id);
  };

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [role, selectRole] = useState("developer");
  const [password, setPassword] = useState(null);
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blockedId, setBlockedId] = useState(null);
  const [unblockedId, setUnblockedId] = useState(null);

  // pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");

  const fetchUsers = async () => {
    try {
      const res = await getUsers({
        page: page,
        limit: limit,
        search: search,
        status:
          activeTab === 1
            ? "active"
            : activeTab === 2
              ? "inactive"
              : activeTab === 3
                ? "invited"
                : "blocked",
      });

      setUsers(res.data?.users || []);
      setTotal(res.data?.totalRows || 0);
    } catch (err) {
      console.error("Failed to fetch users", err);
    } finally {
      setLoading(false);
    }
  };

  const updateUserStatus = async (id, status) => {
    try {
      const res = await updateUser(id, status);
      if (res.status === 200) {
        const response = await getUsers({
          page: page,
          limit: limit,
          search: search,
          status:
            activeTab === 1
              ? "active"
              : activeTab === 2
                ? "inactive"
                : activeTab === 3
                  ? "invited"
                  : "blocked",
        });
        setUsers(response.data?.users || []);
        setTotal(response.data?.totalRows || 0);
        toast.success(status);
      }
    } catch (err) {
      console.error("Failed to update user status", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, limit, search, activeTab]);

  const validateForm = () => {
    const errs = {};
    //gateway type validation
    if (name === null) {
      errs.name = "Name is required";
    }
    //payout amount validation
    // if (!payoutAmount || payoutAmount <= 0) {
    //   errs.payoutAmount = "Amount must be greater than 0";
    // }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      name: name.trim(),
      email: email.trim(),
      role: role,
      password: password,
    };
    const addNewMember = async () => {
      try {
        const dataRes = await registerUser(payload);

        if (dataRes.status === 200 || dataRes.status === 201) {
          // refresh list
          const res = await getUsers({
            page: page,
            limit: limit,
            search: search,
            status: activeTab === 1 ? "active" : "inactive",
          });
          toast.success(
            isEditMode
              ? "User updated successfully"
              : "User added successfully",
          );

          setUsers(res.data?.users || []);

          // close modal and reset
          setIsModalOpen(false);

          setName(null);
          setEmail(null);
          selectRole("developer");
          setPassword("");

          setErrors({});
          setDisabled(false);
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to user ", err);
        // show error toast
      }
    };
    addNewMember();
  };

  const handleBlocked = async () => {
    //setAppConfigs(appConfigs.filter((item) => item.id !== deleteId));
    try {
      const res = await blockUser(blockedId);
      if (res.status === 200) {
        toast.dismiss("blocked Member");
        // refresh list
        if (res.status === 200) {
          const response = await getUsers({
            page: page,
            limit: limit,
            search: search,
            status:
              activeTab === 1
                ? "active"
                : activeTab === 2
                  ? "inactive"
                  : activeTab === 3
                    ? "invited"
                    : "blocked",
          });
          setUsers(response.data?.users || []);
          setTotal(response.data?.totalRows || 0);
        }
      }
    } catch (err) {
      console.error("Failed to delete configuration", err);
      toast.error(err.response?.data?.error || "Failed to delete config");
    }
    setBlockedId(null);
  };
  const handleUnblocked = async () => {
    //setAppConfigs(appConfigs.filter((item) => item.id !== deleteId));
    try {
      const res = await unblockMember(unblockedId);
      if (res.status === 200) {
        toast.dismiss("blocked Member");
        // refresh list
        if (res.status === 200) {
          const response = await getUsers({
            page: page,
            limit: limit,
            search: search,
            status:
              activeTab === 1
                ? "active"
                : activeTab === 2
                  ? "inactive"
                  : activeTab === 3
                    ? "invited"
                    : "blocked",
          });
          setUsers(response.data?.users || []);
          setTotal(response.data?.totalRows || 0);
        }
      }
    } catch (err) {
      console.error("Failed to delete configuration", err);
      toast.error(err.response?.data?.error || "Failed to delete config");
    }
    setUnblockedId(null);
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4">
        {/* tabs */}
        <div className="flex items-center justify-between">
          <div
            className=" px-3 py-2 bg-slate-300/25 dark:bg-slate-900/80 backdrop-blur-xl rounded-lg   
            transition-all duration-300 group "
          >
            {type.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={` text-xs font-normal border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300  ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer "
           }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <SolidButton
            children={
              <>
                <UserPlus className="w-4 h-4" />
                <span>Add Team Member</span>
              </>
            }
            onClick={() => {
              setIsModalOpen(true);
            }}
          />
        </div>
        {/* table */}
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto       
               mt-4 
              "
        >
          <div className="overflow-x-auto">
            {/* Search Outside Table */}
            <div className="my-4 px-4">
              <input
                type="text"
                placeholder="Search by name,email,label..."
                className="w-full md:w-80 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              />
            </div>

            <table className="w-full text-xs text-left">
              <thead>
                <tr className="border-b border-slate-300/40 text-slate-600 dark:text-slate-400">
                  <th className="px-4 py-3 font-semibold min-w-[280px]">
                    Member
                  </th>
                  <th className="px-4 py-3 font-semibold">Label</th>
                  <th className="px-4 py-3 font-semibold">2FA</th>
                  <th className="px-4 py-3 font-semibold">Date Joined</th>
                  <th className="px-4 py-3 font-semibold">Last Session</th>
                  <th className="px-4 py-3 font-semibold text-right">Action</th>
                </tr>
              </thead>

              <tbody>
                {users.map((user, index) => (
                  <tr
                    key={index}
                    className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40 text-slate-700 align-middle"
                  >
                    {/* Member */}
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        {user.img ? (
                          <img
                            className="w-8 h-8 rounded-full object-cover"
                            src={user.img}
                            alt="icon"
                          />
                        ) : (
                          <User className="w-8 h-8 p-1 dark:text-white dark:bg-slate-400 bg-slate-200 text-slate-600 rounded-full" />
                        )}
                        <div>
                          <p className="text-xs font-semibold text-slate-800 dark:text-slate-300">
                            {user.name}
                          </p>
                          <p className="text-[10px] text-slate-500">
                            {user.email}
                          </p>
                        </div>
                      </div>
                    </td>

                    {/* Role */}
                    <td className="text-left py-3">
                      <span className="px-3 py-1 text-[11px] dark:text-slate-100 bg-slate-100 dark:bg-slate-700 rounded-lg font-medium">
                        {user.role}
                      </span>
                    </td>

                    {/* 2FA */}
                    <td className="px-4 py-3">
                      {user.two_fa ? (
                        <CheckCircle className="text-green-500 w-4 h-4" />
                      ) : (
                        <X className="text-red-500 w-4 h-4" />
                      )}
                    </td>

                    {/* Date Joined */}
                    <td className="px-4 py-3 text-slate-600 dark:text-slate-200">
                      {formatDateTime(user.created_at)}
                    </td>

                    {/* Last Session */}
                    <td className="px-4 py-3">
                      <p className="text-slate-700 dark:text-slate-200">
                        {formatDateTime(user.created_at)}
                      </p>
                      <p className="text-[10px] text-slate-400">
                        {user.last_login_ip}
                      </p>
                    </td>

                    {/* Actions */}
                    <td className="px-4 py-3 text-right">
                      <div className="flex items-center justify-end gap-2">
                        {/* Toggle */}
                        {activeTab != 4 && (
                          <div className="ml-auto flex items-start">
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={user.status === "active"}
                                //  value={enableWithdrawal}
                                onChange={(e) => {
                                  const newStatus = e.target.checked;
                                  console.log("status:", newStatus);
                                  updateUserStatus(
                                    user.id,
                                    newStatus ? "active" : "inactive",
                                  );
                                }}
                              />
                              <div
                                className="w-10 h-5 bg-gray-300 dark:bg-gray-400 
              rounded-full peer peer-checked:bg-blue-600 
              transition-all
              after:content-[''] after:absolute after:w-4 after:h-4 
              after:bg-white after:rounded-full 
              after:top-[2px] after:left-[2px]
              peer-checked:after:translate-x-5 
              after:transition-all"
                              ></div>
                            </label>
                          </div>
                        )}

                        {/* <button className="p-2 text-gray-400 dark:text-gray-300 border hover:bg-gray-300/20 dark:hover:bg-gray-300/40 rounded-lg cursor-pointer">
                          <Pencil className=" " size={14} />
                        </button> */}
                        <button
                          onClick={() => {
                            activeTab == 4
                              ? setUnblockedId(user.id)
                              : setBlockedId(user.id);
                          }}
                          className={`p-2 border ${activeTab == 4 ? "hover:bg-green-100 text-green-500" : "hover:bg-red-100 text-red-500"}  rounded-lg`}
                        >
                          {activeTab == 4 ? (
                            <UserCheck size={14} />
                          ) : (
                            <UserX size={14} />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <MyModal
        isOpen={isModalOpen}
        title={"Add Team Member"}
        onClose={() => setIsModalOpen(false)}
        children={
          <>
            {/* profile */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
              Profile Icon
            </h1>
            <div className="w-full flex items-center justify-between space-x-4 mt-2">
              <div className="relative h-14 w-14 overflow-hidden rounded-full">
                {/* <img className="z-4 w-full h-full rounded-full object-cover" src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg" alt="profile" />
                 */}
                <User
                  className="w-full h-full p-2 text-slate-600 dark:text-slate-300
            bg-slate-400/20 dark:bg-slate-700 
            z-9
            "
                />
              </div>
              <button
                className="flex flex-col items-center justify-center space-y-1 border-2
           border-dashed border-slate-400/50 dark:border-slate-600/50 
              hover:border-slate-500 dark:hover:border-slate-500
           rounded-lg p-3 flex-1 cursor-pointer
           transition-all duration-300
           "
              >
                <Upload className="w-6 h-6 text-slate-600 dark:text-slate-400" />
                <span className="text-sm text-slate-600 dark:text-slate-400">
                  Click to upload photo
                </span>
                <span className="text-xs text-slate-600 dark:text-slate-500">
                  PNG,JPG-up to 2MB
                </span>
              </button>
            </div>
            {/* Full Name */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
              Full Name*
            </h1>
            <input
              type="text"
              name="memberName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Member name"
              id=""
              className="w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
            />
            {/* Email */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              Email*
            </h1>
            <input
              type="text"
              name="memberEmail"
              placeholder="Enter Email Addreee"
              id=""
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
            />
            {/* Role */}
            <div className="mt-4">
              <label className="block text-sm  font-medium text-black-600 dark:text-slate-200 mb-1">
                Role*
              </label>
              <select
                id="role"
                name="role"
                value={role}
                defaultValue={"developer"}
                onChange={(e) => {
                  selectRole(e.target.value);
                  if (errors.value)
                    setErrors((prev) => ({ ...prev, value: undefined }));
                }}
                className="w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
              >
                <option value="developer">Developer</option>
                <option value="super-admin">Super Admin</option>
                <option value="admin">Admin</option>
                <option value="marketing">Marketing</option>
                <option value="adsmanager">Ads Manager</option>
                <option value="analyst">Analyst</option>
              </select>
            </div>

            {/* Password */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              Password*
            </h1>
            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter Password"
                id=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                className="absolute right-2 top-1/2  transform -translate-y-1 
              text-slate-400 hover:text-slate-600 dark:hover:text-slate-300
              "
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeOff className="w-4 h-4" />
                ) : (
                  <Eye className="w-4 h-4" />
                )}
              </button>
            </div>
            {/* line */}
            <div className="w-full h-[1px] bg-white/70 dark:bg-slate-600 mt-3"></div>
            <div className="flex items-center justify-end space-x-4 mt-4">
              <button
                className="px-4 py-2 rounded-lg
             bg-slate-400/20 dark:bg-slate-800 
             text-slate-800 dark:text-slate-300 text-sm font-semibold
             hover:bg-slate-400/30 dark:hover:bg-slate-700 
             transition-all duration-300"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <SolidButton
                children={<span>Add Member</span>}
                onClick={() => handleSubmit()}
              />
            </div>
          </>
        }
      />
      {/* block CONFIRM MODAL */}
      <MyModal
        isOpen={!!blockedId}
        title="Block Member?"
        onClose={() => setBlockedId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to block this member?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setBlockedId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleBlocked} children={<span>Block</span>} />
        </div>
      </MyModal>
      {/* unblock CONFIRM MODAL */}
      <MyModal
        isOpen={!!unblockedId}
        title="Unblock Member?"
        onClose={() => setUnblockedId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to unblock this member?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setUnblockedId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton
            onClick={handleUnblocked}
            children={<span>unblock</span>}
          />
        </div>
      </MyModal>
    </Fragment>
  );
}
